<!--

 -->

<template>
  <employee-autocomplete
    :label="$t('performance.supervisor_reviewer')"
    :clear="false"
    :create-options="loadEmployees"
    required
  />
</template>

<script>
import EmployeeAutocomplete from '@/core/components/inputs/EmployeeAutocomplete';
import {APIService} from '@/core/util/services/api.service';

export default {
  name: 'SupervisorAutoComplete',
  components: {
    'employee-autocomplete': EmployeeAutocomplete,
  },
  props: {
    subordinate: {
      type: Object,
      required: false,
      default: null,
    },
  },
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      `/api/v2/performance/supervisors`,
    );
    return {
      http,
    };
  },
  methods: {
    async loadEmployees(serachParam) {
      return new Promise((resolve) => {
        if (serachParam.trim() && this.subordinate) {
          this.http
            .getAll({
              nameOrId: serachParam.trim(),
              empNumber: this.subordinate.id,
            })
            .then(({data}) => {
              resolve(
                data.data.map((employee) => {
                  return {
                    id: employee.empNumber,
                    label: `${employee.firstName} ${employee.middleName} ${employee.lastName}`,
                    isPastEmployee: employee.terminationId ? true : false,
                  };
                }),
              );
            });
        } else {
          resolve([]);
        }
      });
    },
  },
};
</script>
